import React from 'react';
import AssignmentActionFlowModal, {
	ActionTarget,
	ActionTargetOption
} from '../AssignmentActionFlowModal';

export type ResetTarget = ActionTarget;

const RESET_OPTIONS: ActionTargetOption[] = [
	{
		value: 'all',
		title: 'All previously selected users',
		description:
			'Reset this training for all users included in the last assignment.'
	},
	{
		value: 'specific',
		title: 'Specific users',
		description:
			'Reset this training for selected users only, based on property, role, group or individual selection.'
	}
];

interface ResetCompletionModalProps {
	visible: boolean;
	onCancel: () => void;
	onContinue: (target: ResetTarget) => void;
}

const ResetCompletionModal: React.FC<ResetCompletionModalProps> = ({
	visible,
	onCancel,
	onContinue
}) => (
	<AssignmentActionFlowModal
		visible={visible}
		onCancel={onCancel}
		onContinue={onContinue}
		select={{
			title: 'Reset training',
			description: 'Choose who you want to reset this training from.',
			options: RESET_OPTIONS,
			actionLabel: 'Continue'
		}}
		confirmAll={{
			title: 'Reset training?',
			intro: 'Resetting this training will:',
			items: ['Reset progress for 200 learners'],
			actionLabel: 'Reset'
		}}
		specific={{
			title: 'Reset specific users',
			description: 'Reset users from this training',
			actionLabel: 'Continue'
		}}
		confirmSpecific={{
			title: 'Confirm reset',
			intro: 'Resetting this training will:',
			items: [
				'Affect 2 properties',
				'Reset progress for 5 learners',
				'Affect 430 learners total'
			],
			actionLabel: 'Reset'
		}}
	/>
);

export default ResetCompletionModal;
